import React from "react";
import { Container, Navbar, Nav, NavDropdown, Form, Button } from "react-bootstrap";
import Logo from "../img/logo-blue.png";
import "../css/header.css";

const Header = () => {
  const brokerageSavedToday = 5923894; // Example value

  return (
    <>
      {/* Stock Price Scroller & Brokerage Counter in One Line */}
      <div
        style={{
          backgroundColor: "#00A877",
          color: "white",
          padding: "0",
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
        }}
      >
        {/* Stock Price Scroller (75%) */}
        <div
          style={{
            width: "110%",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "inline-block",
              animation: "scroll 27s linear infinite",
              fontWeight: "600",
            }}
          >
            JSW Steel Share Price: NSE 931.95 -2.95 (0.32%) &nbsp; &nbsp; &nbsp;  JSW Steel Share Price: NSE 931.95 -2.95 (0.32%) &nbsp; &nbsp; &nbsp;  JSW Steel Share Price: NSE 931.95 -2.95 (0.32%) &nbsp; &nbsp; &nbsp;
          </div>
        </div>

        {/* Brokerage Saved Counter (25%) */}
        {/* <div style={{ width: "25%", textAlign: "center", paddingRight: "10px", backgroundColor: '#0f2f50', borderRadius: '50px 0 0 50px' }}>
          <div style={{ fontSize: "12px", fontWeight: "bold", color: '#00a877' }}>Brokerage Saved Today</div>
          <div style={{ display: "flex", gap: "2px", justifyContent: "center", marginBottom: '10px', marginTop: '3px' }}>
            {brokerageSavedToday.toString().split("").map((num, index) => (
              <span
                key={index}
                style={{
                  // background: "#fff",
                  color: "#ffff",
                  padding: "3px 6px", // Reduced size
                  borderRadius: "3px",
                  fontSize: "14px", // Reduced font size
                  fontWeight: "bold",
                  border: '2px solid #ffff'
                }}
              >
                {num}
              </span>
            ))}
          </div>
        </div> */}
      </div>

      {/* Main Navbar */}
      <Navbar expand="lg" style={{ backgroundColor: "#ffffff" }}>
        <Container>
          <Navbar.Brand href="#">
            <img src={Logo} alt="Angel One Logo" style={{ height: "20px" }} />
            <div style={{ fontSize: "12px", color: "#6c757d" }}>ASSOCIATE PARTNER</div>
          </Navbar.Brand>

          <Form className="d-none d-lg-flex mx-auto" style={{ width: "40%" }}>
            <Form.Control
              type="text"
              placeholder="Search Stocks, News, Reports..."
              style={{
                borderRadius: "20px",
                height: "38px",
              }}
            />
          </Form>

          <div className="d-none d-lg-flex align-items-center">
            <Button
              href="#"
              className="me-2"
              style={{
                backgroundColor: "#0f2f50",
                border: "none",
                borderRadius: "5px",
                padding: "6px 16px",
              }}
            >
              Open Account
            </Button>
          </div>

          <Navbar.Toggle aria-controls="navbar-nav" />
        </Container>
      </Navbar>

      {/* Secondary Navbar */}
      <Navbar expand="lg" style={{ backgroundColor: "#0f2f50" }}>
        <Container>
          <Navbar.Collapse id="navbar-nav">
            <Nav className="mx-auto">
              <Nav.Link href="#" className="px-3 me-3">Pricing</Nav.Link>
              <NavDropdown className="me-3 px-3" title="Services" id="navbarScrollingDropdown">
                <NavDropdown.Item href="#">Demat Account</NavDropdown.Item>
                <NavDropdown.Item href="#">Commodity Trading</NavDropdown.Item>
                <NavDropdown.Item href="#">Equity Trading</NavDropdown.Item>
                <NavDropdown.Item href="#">Derivatives Trading</NavDropdown.Item>
                <NavDropdown.Item href="#">Currency Trading</NavDropdown.Item>
                <NavDropdown.Item href="#">MTF</NavDropdown.Item>
                <NavDropdown.Item href="#">ALGO Trading</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="#" className="px-3 me-3">IPO</Nav.Link>
              <Nav.Link href="#" className="px-3 me-3">Support</Nav.Link>
              <Nav.Link href="#" className="px-3 me-3">Products</Nav.Link>
              <Nav.Link href="#" className="px-3 me-3">Contact</Nav.Link>

            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* CSS for scrolling animation */}
      <style>
        {`
          @keyframes scroll {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(-100%);
            }
          }
        `}
      </style>
    </>
  );
};

export default Header;
